export default {
  apiRootUrl: ""
};



// WEBPACK FOOTER //
// ./src/config.ts